import React, {useEffect, useState, useCallback } from "react"
const SITE_KEY = process.env.GOOGLE_CAPT_SITE_KEY;
const ContactForm = (props) => {    
    //const [token, setToken] = useState('');
       
    const [state, setState] = useState({to: process.env.CONTACT_FORM_TO, name: '', email:'', message:'', subject:'Franchise Acquisition Form Submission', consent:true, googleCaptchaToken:''});

    useEffect(() => {
      const loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);
  
        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }
  
        if (isScriptExist && callback) callback();
      }
  
      // load the script by passing the URL
      loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
        console.log("Script loaded!");        
      });
    }, []);

    const isContactSubmitted = (displayMessage) => {      
      var message = document.getElementById("msg");
      if(displayMessage)
      {
         message.style.display = "block"         
      }
      else
      {
        message.style.display = "none"
      }      
  } 
  const clearFormFields = () => {
    var name =  document.getElementById('Name');    
    var email =  document.getElementById('Email');     
    var message =  document.getElementById('Message');  
    name.value = '';
    email.value = '';
    message.value = '';
  }
  const handleChange = (event) => {
      //alert(event.target.value);
    setState({...state,[event.target.name]: event.target.value});
  }

  const handleChangeCheckBox = (event) => {
    //alert(event.target.checked);
    setState({...state,[event.target.name]: event.target.checked});
  }

  const handleSubmit = (event) => { 
    document.getElementById('formSubmitBtn').style.display = "none";   
    if(validateForm())
    {      
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(SITE_KEY, { action: 'contact_us' }).then(token => {
          setState({googleCaptchaToken: state.googleCaptchaToken = token});                    
          submitData();
        });
      });
    }
    clearFormFields();        
    document.getElementById('formSubmitBtn').style.display = "initial";
    event.preventDefault();    
  }

  const submitData = () => {
    fetch(process.env.MAIL_GUN_API, {
      method: 'POST', headers: {'Content-Type':'application/json'},
      // We convert the React state to JSON and send it as the POST body
      body: JSON.stringify(state)
    }).then(function(response) {
      console.log("This is the response from the api: " + response.status);      
      if(response.ok)
      {
        isContactSubmitted(true);    
      }
      else{
        alert(response.statusText);
      }
      return response.json();        
    });    
  }      

  const validateForm = (e) => {
    //fields
    var pass = true;    
    var name =  document.getElementById('Name');    
    var email =  document.getElementById('Email');     
    var message =  document.getElementById('Message');  
    var nameError = document.getElementById('name--error');    
    var emailError =  document.getElementById('email--error');      
    var messageError =  document.getElementById('message--error');    
    if(name.value.length < 1)
    {
        nameError.style.display="block";
        pass = false;
    }
    if(email.value.length < 1)
    {
        emailError.style.display="block";
        pass = false
    }
    if(message.value.length < 1)
    {
        messageError.style.display="block";
        pass = false
    }    
    return pass;       
  } 

  useEffect(() => {
      if (isContactSubmitted()) {
          var el = document.getElementById('jl-contact-form');

          if (el)
              el.scrollIntoView();
      }
  }, [props.location]);

  return (
    <section id="jl-contact-form" className="jl-contact" style={{ display: "block"}}>
        <div className="container" style={{maxWidth: "500px"}}>
            <div className="subheader">
                <h3 className="subheader">Want to talk about selling your business?</h3>
                <p>Give us a call at</p>
                <p className="telNo"><a href="tel:(346) 325-9987"><i className="fas fa-phone-alt"></i> (346) 325-9987 </a></p>                
                <p>or send an email to</p>
                <p className="email"><a href="mailto:acquisitions@jiffymarketing.com"><i className="fas fa-email-alt"></i> acquisitions@jiffymarketing.com </a></p>                
                <p>Or, you can simply submit the form below and we will be in touch shortly!</p>
            </div>
            <div id="formOuter">
            {/*<form id="shortContactForm" action={"https://mailthis.to/"+process.env.CONTACT_FORM_TO} method="post" encType="multipart/form-data" onSubmit={validateForm}>*/}
            <form id="shortContactForm" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="Name">Name</label>
                    <input aria-describedby="name--error" className="jl-feedback-txtfield" id="Name" name="name" value={state.value} onChange={handleChange}  type="text" /><br/>
                    <span className="field-validation-valid text-white" id="name--error" style={{display: "none"}}>The Name field is required.</span>
                </div>
                <div className="form-group">
                    <label htmlFor="Email">Email</label>
                    <input aria-describedby="email--error" className="jl-feedback-txtfield" id="Email" name="email" type="text" value={state.value} onChange={handleChange}  /><br/>
                    <span className="field-validation-valid text-white" id="email--error" style={{display: "none"}}>The Email field is not a valid e-mail address.</span>
                </div>
                <div className="form-group">
                    <label htmlFor="Message">Message</label>
                    <textarea aria-describedby="message--error" className="jl-feedback-txtfield" id="Message" value={state.value} onChange={handleChange}  name="message"></textarea><br/>
                    <span className="field-validation-valid text-white" id="message--error" style={{display: "none"}}>The Message field is required.</span>
                </div>
                <div class="form-check">                
                    <label class="form-check-label" for="exampleCheck1">
                    <input type="checkbox" class="form-check-input" id="exampleCheck1" value={state.ch} onChange={handleChangeCheckBox} name="consent" defaultChecked />
                    &nbsp;&nbsp;I consent to receive marketing communication about promotional offers and news or information from Jiffy Lube via email, including tailored offers based on analysis of my use of Jiffy Lube services, websites, apps, and other digital channels, my purchase history, my participation in promotions, surveys, and other Jiffy Lube programs, as well as other data I have provided to Jiffy Lube in accordance with the Jiffy Lube Privacy Policy, available at <a href="https://www.jiffylube.com/privacy-policy" target="_blank">https://www.jiffylube.com/privacy-policy.</a>  I understand I can change my preferences or opt out at any time as provided in the Privacy Policy.
                    </label>
                </div>
                {/* <input type="hidden" name="_after" value={process.env.CONTACT_FORM_REDIRECT+"/?contact=true"} />*/}
                <button type="submit" id="formSubmitBtn" value="Send">Submit</button><br/>
                <span id="msg">Our team will be in touch with you shortly. Talk to you soon!</span>
            </form>
            </div>
        </div>
    </section>
  );
}

export default ContactForm;